import React, { useState } from 'react';
import 'AppSrc/core/style/components/tables/vf-table.css';
import { SortableListTable } from 'AppSrc/core/components/tables/sortable-list-table';
import { PaginationControls } from 'AppSrc/core/components/tables/pagination-controls';
import PropTypes from 'prop-types';
import { listTableColumnPropShape, sortableListTableRowPropShape } from './table-proptypes';


const PaginatedSortableListTable = ({
  rows,
  columns,
  rowsPerPage,
  onClickRow,
  className,
  initialSortedColumn,
  initialSortDesc,
  noResultsMessage,
  isDuplicate,
}) => {
  // set up a state variable for current page
  const [currentPage, setCurrentPage] = useState(1);
  return (
    <>
      <div className="page-content-inner table-container">
        <SortableListTable
          className={className}
          columns={columns}
          rows={rows}
          onClickRow={onClickRow}
          currentPage={currentPage}
          rowsPerPage={rowsPerPage}
          initialSortedColumn={initialSortedColumn}
          initialSortDesc={initialSortDesc}
          noResultsMessage={noResultsMessage}
          isDuplicate={isDuplicate}
        />
      </div>
      <div className="table-foot">
        <div className="page-content-inner">
          <PaginationControls
            totalRows={rows.length}
            currentPage={currentPage}
            rowsPerPage={rowsPerPage}
            setCurrentPage={setCurrentPage}
          />
        </div>
      </div>
    </>
  );
};

PaginatedSortableListTable.propTypes = {
  columns: PropTypes.arrayOf(listTableColumnPropShape),
  rows: PropTypes.arrayOf(sortableListTableRowPropShape),
  onClickRow: PropTypes.func,
  className: PropTypes.string,
  rowsPerPage: PropTypes.number,
  initialSortedColumn: PropTypes.string,
  initialSortDesc: PropTypes.bool,
  noResultsMessage: PropTypes.string,
  isDuplicate: PropTypes.bool,
};

export { PaginatedSortableListTable };
